import * as React from 'react';
import { Icon } from '../components/ui'
import { HeaderBar, HeaderBarCSS } from '../components/templates'

// Contains all the different 
// actions that can be called
interface OverlayActionMap {
  'Open': {
    content: JSX.Element
    title: string,
    onTitleClick?: () => void,
    hideTitle?: boolean
  }
  'Close': undefined,
  'SetTitle': string
}
type Action = {type: keyof OverlayActionMap, payload?: any}

interface DispatchActionFunc {
  (type: 'Close'): void
  <K extends keyof OverlayActionMap>(type: K, payload: OverlayActionMap[K]): void
}

const initialState = {
  isOpen: false,
  content: null as null | JSX.Element,
  title: null as null | string,
  onTitleClick: null as null | (() => void),
  hideTitle: false as boolean
}

export const OverlayContext = React.createContext({
  ...initialState,
  dispatchAction: ((a: Action, p: any) => {}) as DispatchActionFunc
})
export interface OverlayContext {
  dispatchAction: DispatchActionFunc
}

export function OverlayProvider(props: {children?: React.ReactNode}) {

  const [state, dispatch] = React.useReducer(reducer, initialState);

  const dispatchAction: DispatchActionFunc = function<K extends keyof OverlayActionMap>(type: K, payload?: OverlayActionMap[K]){
    dispatch({ type, payload })
  }

  // The reducer takes care of state updates.
  function reducer(state: typeof initialState, action: Action) {
    switch (action.type) {
      case 'Open':
        return {
        ...state, 
        isOpen: true, 
        content: action.payload.content, 
        title: action.payload.title, 
        onTitleClick: action.payload.onTitleClick,
        hideTitle: action.payload.hideTitle
      }
      case 'Close':
        return {...state, isOpen: false, content: null, title: null, onTitleClick: null }
      case 'SetTitle':
        return {...state, title: action.payload }
      default:
        return state;
    }
  }

  // Renders te actual overlay if state.isOpen is truthy
  function renderOverlay() {
    const { isOpen, content, title, onTitleClick, hideTitle } = state;
    if (!isOpen) {
      return null;
    }
    return (
      <div className="flex flex-col h-screen w-screen bg-white z-[999] absolute inset-0">
        {!hideTitle &&
          <HeaderBar backButton={undefined}>
            <div className="flex justify-between" style={{ height: '5em' }}>
              <div onClick={onTitleClick} className={HeaderBarCSS.title}>
                <div className="truncate min-w-[75vw] max-w-[75vw]">{title}</div>
              </div>
              <div className={HeaderBarCSS.title}>
                <Icon
                  type="close"
                  className={HeaderBarCSS.overlayBackIcon}
                  style={{padding: 0}}
                  onClick={(e) => {e.stopPropagation(); dispatchAction('Close')}}
                />
              </div>
            </div>
          </HeaderBar>
        }
        {content}
      </div>
    )
  }

  return (
    <OverlayContext.Provider value={{...state, dispatchAction}}>
      {props.children}
      {renderOverlay()}
    </OverlayContext.Provider>
  )
}

